import type { components } from '../../../generated/fct';
import { ApiError, ApiRequest } from '../../shared';

type GeneratedNoteEntry = components['schemas']['NoteEntry'];

export type NoteLinkedTo = components['schemas']['LinkedTo'];

export type NoteTitle = components['schemas']['NoteTitle'];

export type CarePlanNote = Omit<GeneratedNoteEntry, 'activityType' | 'createdDate' | 'noteId'> & {
  activityType: string;
  createdDate: string;
  noteId: string;
};

export interface CarePlanNotesPayload {
  care_plan_id: string;
  includeEventLog?: boolean;
  title?: null | string;
}

export type CarePlanNotesRequest = ApiRequest<CarePlanNotesPayload>;

export type CarePlanNotesResponse = Omit<
  components['schemas']['CarePlanNotesResponse'],
  'notes'
> & {
  notes?: CarePlanNote[];
};

export type CarePlanNotesError = ApiError<unknown>;

export const CARE_PLAN_ACTIVITY_TYPE = {
  APPROPRIATENESS_REVIEW: 'Appropriateness Review',
  SAFETY_CHECK: 'Safety Check',
} as const;

export type CarePlanActivityType =
  (typeof CARE_PLAN_ACTIVITY_TYPE)[keyof typeof CARE_PLAN_ACTIVITY_TYPE];

export const CARE_PLAN_ACTIVITY_NOTE_TITLE = {
  AD_HOC_NOTES: 'Ad-hoc Notes',
  CRITICAL_RESULTS_NOTIFICATION: 'Critical Results Notification',
  DECISION_STATUS_CHANGES: 'Decision / Status Changes',
  RADIOLOGIST_NOTES: 'Radiologist Notes',
} as const;

export type CarePlanActivityNoteTitle =
  (typeof CARE_PLAN_ACTIVITY_NOTE_TITLE)[keyof typeof CARE_PLAN_ACTIVITY_NOTE_TITLE];

export type CreateCarePlanActivityNoteBody = components['schemas']['CreateNoteRequest'];

export interface CreateCarePlanActivityNotePayload {
  activity_id: string;
  body: CreateCarePlanActivityNoteBody;
}

export type CreateCarePlanActivityNoteRequest = ApiRequest<CreateCarePlanActivityNotePayload>;

export type CreateCarePlanActivityNoteResponse = Omit<
  components['schemas']['ActivityNotesResponse'],
  'notes'
> & {
  notes?: CarePlanNote[];
};

export type CreateCarePlanActivityNoteError = ApiError<unknown>;
